import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode
} from 'react';

export type AppConfig = {
  apiUrl: string;
  featureFlag: boolean;
  VITE_KEY: string;
  VITE_PROVIDER_FINDER_URL: string;
  VITE_PROVIDER_FINDER_URL_NC: string;
  VITE_PROVIDER_FINDER_URL_GA: string;
  VITE_RMPHQueueId: string;
  VITE_GF360QueueId: string;
  VITE_CII_DISCOVER_REDIRECT_URL: string;
  VITE_CII_CRX_REDIRECT_URL: string;
  VITE_SAML_URL: string;
  VITE_SAML_ASSERTION_CONSUMER_URL: string;
  VITE_SAML_RELAY_STATE_URL: string;
  VITE_SAML_ISSUER: string;
  VITE_ENV: string;
  VITE_NC_QUEUE_ID_MAP_CONFIG: string;
  VITE_NCDIT_SSO_URL: string;
  VITE_HEALTHY_REWARDS_REDIRECT_URL: string;
  VITE_LP_SITE_ID: string;
};

const ConfigContext = createContext<AppConfig | undefined>(undefined);

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};

export const ConfigProvider = ({ children }: { children: ReactNode }) => {
  const [config, setConfig] = useState<AppConfig | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      const res = await fetch('/config.json');
      const text = await res.text();
      const data = JSON.parse(text); 
      setConfig(data);
      setLoading(false);
    };
    fetchConfig();
  }, []);

  if (loading || !config) {
    return <div>Loading configuration...</div>;
  }

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};
